import Super from 'client-portal/routes/-request/client-type';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestClientType extends Super {}
